/* @flow */

import {FEEDBACK_SURVEYS, type FeedbackSurvey} from './feedback-surveys';

export function isSurveyExpired(expireDate: ?string): boolean {
    if (!expireDate) {
        return false;
    }

    const newDate = new Date(expireDate);

    return newDate < new Date();
}

export function matchSurvey(pathnameToMatch: string): ?FeedbackSurvey {
    for (const survey of FEEDBACK_SURVEYS) {
        for (const pathPattern of survey.pathNames) {
            // Escape regex special characters
            const escapedPattern = pathPattern.replace(/[-/\\^$+?.()|[\]{}]/g, '\\$&');
            const wildcardRegex = new RegExp(`^${escapedPattern.replace(/\*/g, '.*')}$`);

            if (wildcardRegex.test(pathnameToMatch)) {
                return survey;
            }
        }
    }

    return null;
}
